var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('shortcut-bar',{staticStyle:{"z-index":"999","position":"fixed"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"56px"}}),_vm._v(" "),_c('search-area')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a60aeaf","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = null
// module chunks = 